import React from "react";
import YoutubePlayer from "react-player/youtube";

export default function EmebedVideo({ data, cls = "" }) {
  return (
    <div className={`${cls} my-3 player-wrapper`}>
      <YoutubePlayer
        url={data.url}
        controls
        className="react-player"
        width="100%"
        height="100%"
      />
    </div>
  );
}
